//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateCajaChicas } from "@/typings/store/plugins/easyFirestore/cajaChicas";

const getters: GetterTree<StateCajaChicas, State> = {
    get(state) {
        return state.all;
    },
    getArray(state) {
        return Object.values(state.all);
    },
};

const cajaChicas = {
    firestorePath: "dev/v1/cajaChicas",
    firestoreRefType: "collection",
    moduleName: "cajaChicas",
    statePropName: "all",
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: "%convertTimestamp%", // default
            updated_at: "%convertTimestamp%", // default
        },
    },
    state: {},
    getters,
    mutations: {},
    actions: {},
};

export default cajaChicas;
